// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3VxLx","title":"InfoRow_title__zoy3T"};